module.exports = __webpack_public_path__ + "media/images/games/k2gender/buildingwithblocks-7cdaec43db765b27fd60c5ebea054f61.png";